<div class="row">
  <div class="col-md-4" style="padding-left:8px;padding-right: 4px;">
    <!--<div *ngIf="bike.ImageURL.indexOf('no_image')===-1">
      <div [ngStyle]="{'background-image': 'url(' + bike.ImageURL + ')'}" class="bike-image"></div>
    </div>-->

    <div *ngIf="!editBike" class="details-container">
      <div class="row" *ngIf="partner.PartnerType === 1">
        <div class="col-md-5 label">{{ 'general.headers.type' | translate }}:</div>
        <div class="col-md-7 value">{{getBikeType(bike.TypeID)}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.manufacturer' | translate }}:</div>
        <div class="col-md-7 value">{{bike.Manufacturer}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.model' | translate }}:</div>
        <div class="col-md-7 value">{{bike.Model}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.year' | translate }}:</div>
        <div class="col-md-7 value">{{bike.ModelYear == "0" ? "" : bike.ModelYear}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.color' | translate }}:</div>
        <div class="col-md-7 value">{{bike.Colour}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.size' | translate }}:</div>
        <div class="col-md-7 value">{{bike.BikeSize}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.serial_no' | translate }}:</div>
        <div class="col-md-7 value">{{bike.SerialNo}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-12">
          <button pButton (click)="setupEditBike();" class="p-button-raised full-width"
                  label="{{ 'bikeshop.modal.shared.bike.button.edit_bike_details' | translate }}"></button>
        </div>
      </div>
    </div>

    <div *ngIf="editBike" class="details-container">
      <form [formGroup]="BikeForm" (ngSubmit)="updateBike(BikeForm.value)">
        <div class="row" *ngIf="partner.PartnerType === 1">
          <div class="col-md-4 label">{{ 'general.headers.type' | translate }}:</div>
          <div class="col-md-8">
            <p-dropdown [options]="bikeTypes" formControlName="TypeID">
            </p-dropdown>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label" [ngClass]="{'red': !BikeForm.value['Manufacturer']}">
            *{{ 'bikeshop.modal.shared.bike.manufacturer' | translate }}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-autoComplete formControlName="Manufacturer" [suggestions]="manufacturers"
                              placeholder="{{ 'bikeshop.modal.shared.bike.manufacturer' | translate }}"
                              [forceSelection]="false" (completeMethod)="searchManufacturer($event)">
                <ng-template let-manufacturer pTemplate="item">
                  <div><span>{{manufacturer}}</span></div>
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label" [ngClass]="{'red': !BikeForm.value['Model']}">
            *{{ 'bikeshop.modal.shared.bike.model' | translate }}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-autoComplete formControlName="Model" [suggestions]="models"
                              placeholder="{{ 'bikeshop.modal.shared.bike.model' | translate }}"
                              [forceSelection]="false" (completeMethod)="searchModel($event)">
                <ng-template let-model pTemplate="item">
                  <div><span>{{model}}</span></div>
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label">{{ 'bikeshop.modal.shared.bike.year' | translate }}:</div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <input type="number" pInputText
                     placeholder="{{ 'bikeshop.modal.shared.bike.year' | translate }}"
                     formControlName="ModelYear" maxlength="4" />
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label">{{ 'bikeshop.modal.shared.bike.color' | translate }}:</div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <input type="text" pInputText
                     placeholder="{{ 'bikeshop.modal.shared.bike.color' | translate }}"
                     formControlName="Colour" />
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label">{{ 'bikeshop.modal.shared.bike.size' | translate }}:</div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <input type="text" pInputText
                     placeholder="{{ 'bikeshop.modal.shared.bike.size' | translate }}"
                     formControlName="BikeSize" />
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-4 label">{{ 'bikeshop.modal.shared.bike.serial_no' | translate }}:</div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <input type="text" pInputText
                     placeholder="{{ 'bikeshop.modal.shared.bike.serial_no' | translate }}"
                     formControlName="SerialNo" />
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-12">
            <button pButton type="submit" [disabled]="!BikeForm.valid || updating"
                    class="p-button-raised full-width"
                    label="{{updating ? ('general.please_wait' | translate) : ('bikeshop.modal.shared.bike.button.save_bike_details' | translate) }}"></button>
          </div>
        </div>
      </form>
    </div>


    <div class="details-container margin-top-8" *ngIf="partner.PartnerType === 1">
      <div class="row">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.last_service_date' | translate }}:</div>
        <div class="col-md-7 value">{{bike.LastService | date : countryData.AngularDateFormat }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">
          {{ 'bikeshop.modal.shared.bike.bike' | translate }} {{distanceMetric}}:
        </div>
        <div class="col-md-7 value">{{bike.Km}} {{distanceMetric}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">
          {{ 'bikeshop.modal.shared.bike.bike' | translate }} {{ 'general.hours' | translate }}
          :
        </div>
        <div class="col-md-7 value">{{bike.MovingTime / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">
          {{distanceMetric}} {{ 'bikeshop.modal.shared.bike.since_last_service' | translate }}
          :
        </div>
        <div class="col-md-7 value">{{bike.KmSinceLastService}} {{distanceMetric}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">
          {{ 'bikeshop.modal.shared.bike.time_since_last_service' | translate }}:
        </div>
        <div class="col-md-7 value">{{bike.MovingTimeSinceLastService / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">
          {{distanceMetric}} {{ 'bikeshop.modal.shared.bike.to_next_service' | translate }}
          :
        </div>
        <div class="col-md-7 value">{{bike.KmToNextService}} {{distanceMetric}}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-5 label">{{ 'bikeshop.modal.shared.bike.time_to_next_service' | translate }}:</div>
        <div class="col-md-7 value">{{bike.MinutesToNextService / 60 | number : '.1-1'}} {{ 'general.hrs' | translate }}</div>
      </div>
    </div>
  </div>

    <div class="col-md-8" style="padding-left:4px;padding-right: 8px;">

      <app-item-service-history [bike]="bike" *ngIf="bike.UserID && useNew"></app-item-service-history>

      <div *ngIf="!useNew" class="carousel-container">
        <p-carousel [value]="services"
                    styleClass="carousel"
                    [numScroll]="1"
                    [numVisible]="2">
          <ng-template pTemplate="header">
            <div class="p-carousel-header-title">
              {{ 'bikeshop.modal.shared.bike.previous_services' | translate }}
              ({{services.length}})
            </div>
          </ng-template>
          <ng-template let-service pTemplate="item">
            <div class="record alt"
                 [ngClass]="{ 'clickable' : service.PartnerID == partnerID && service.ID !== jobcard.ID, 'non-clickable': service.PartnerID !== partnerID || service.ID === jobcard.ID }"
                 (click)="openJobcard(service)">
              <div class="title">
                <b>{{service.JobCardNo}}</b><span class="fa fa-fw fa-check-square"
                                                  *ngIf="service.DateCompleted"></span>
              </div>
              <div class="record-row">
                <div class="label">{{ 'bikeshop.modal.shared.bike.shop' | translate }}:</div>
                <div class="value">{{service.PartnerDescription}}</div>
              </div>
              <div class="record-row">
                <div class="label">{{ 'bikeshop.modal.shared.bike.service_date' | translate }}:</div>
                <div class="value">{{service.DateCheckedIn | date : countryData.AngularDateFormat}}</div>
              </div>
              <div class="record-column margin-top-8">
                <div class="label">{{ 'bikeshop.modal.shared.bike.service_information' | translate }}:</div>
                <div class="value">{{service.TypeDescription}}</div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
        <div *ngIf="services.length===0 && !loading" class="margin-top-8">
          <i>{{ 'bikeshop.modal.shared.bike.no_services' | translate }}</i>
        </div>
      </div>
      <div class="margin-top-8" *ngIf="!useNew"></div>
      <div class="carousel-container bike-carousel" *ngIf="partner.PartnerType === 1 && !useNew">
        <p-carousel [value]="bikeGear" [numVisible]="2" [numScroll]="1">
          <ng-template pTemplate="header">
            <div class="p-carousel-header-title">
              {{ 'bikeshop.modal.shared.bike.bike_components' | translate }}
              ({{bikeGear.length}})
            </div>
          </ng-template>
          <ng-template let-gear pTemplate="item">
            <app-component-view [gear]="gear" (update)="refreshBike()" [distanceMetric]="distanceMetric"
                                [countryData]="countryData"></app-component-view>
          </ng-template>
        </p-carousel>
        <div class="fa fa-plus font-button pull-right add-component" (click)="addNewComponent()"></div>
        <div *ngIf="bikeGear.length===0" class="margin-top-8">
          <i>{{ 'bikeshop.modal.shared.bike.no_components' | translate }}</i>
        </div>
      </div>

  </div>
</div>
